export default "__VITE_ASSET__BWactGgD__"